<template>
    <div>
        <a href="#" @click.prevent="openMenu" class="slide-menu-open" :class="className">
            <i v-if="material" class="material-icons">{{ material }}</i>
            <i class="" :class="icon" v-else></i>
            <span>{{ menuLabel }}</span>
        </a>
        <div class="side-menu-overlay" style="width: 0; opacity: 0;" @click.prevent="openMenu"></div>
        <div class="side-menu-wrapper">
            <a href="#" class="menu-close" @click.prevent="openMenu">
                <div class="myaccount-logo">
                    <img class="myaccount-img" src="../../assets/images/logo.png" alt=""/>
                    <span>My Account</span>
                </div>
            </a>
            <ul>
                <li v-for="(menu, index) in menus.filter(item => (!userId && item.public) || (userId && item.title !== 'Login'))" :key="index">
                    <a v-if="menu.url" :href="menu.url" :id="`menu-${menu.title}`" @mouseover="hovered = menu.title"
                       @mouseout="hovered = ''" :path="menu.path">
                        <div class="icon">
                            <img :alt="menu.image" class="menu-img"
                                 :src="require(`@/assets/images/${(label === menu.title || menu.title === hovered) ? menu.active_image : menu.image}`)">
                        </div>
                        <div class="menu_title"><span>{{ menu.title }}</span></div>
                    </a>

                    <router-link v-if="!menu.url" :to="{ name: menu.name }" :id="`menu-${menu.title}`"
                                 @mouseover.native="hovered = menu.title" @mouseout.native="hovered = ''"
                                 :class="{ active: label === menu.title}" :path="menu.path"
                                 @click.native="clickNav(menu, index)">
                        <div class="icon">
                            <img :alt="menu.image" class="menu-img"
                                 :src="require(`@/assets/images/${(label === menu.title || menu.title === hovered) ? menu.active_image : menu.image}`)">
                        </div>
                        <div class="menu_title"><span>{{ menu.title }}</span></div>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'vue-menu-overlay',
    props: {
        menus: { type: Array },
        label: { default: String },
        icon: { default: String },
        material: { default: String },
        className: { default: String },
        currentpath: { default: String }
    },
    data () {
        return {
            open: false,
            path: '',
            currentNum: 0,
            menuLabel: this.label,
            hovered: ''
        }
    },
    methods: {
        openMenu () {
            this.open = !this.open
            const slideBar = document.querySelector('.side-menu-wrapper')
            const overlay = document.querySelector('.side-menu-overlay')
            if (this.open) {
                slideBar.style.left = '0px'
                overlay.style.opacity = 1
                overlay.style.width = '100%'
            } else {
                slideBar.style.left = `-320px`
                overlay.style.opacity = 0
                overlay.style.width = 0
            }
        },
        clickNav (menu, index) {
            this.openMenu()
            this.currentNum = index
            this.menuLabel = menu.title
        }
    },
    computed: {
        ...mapGetters({
            userId: 'auth/userId'
        })
    }
}
</script>

<style scoped lang="scss">
    .side-menu-wrapper {
        overflow: hidden;
        background: rgba(255, 255, 255, 1);
        padding: 0;
        position: fixed;
        top: 0;
        left: -320px;
        height: 100%;
        z-index: 2;
        transition: 0.5s;
        width: 320px;
        font-size: 20px;
    }

    .side-menu-wrapper > ul {
        list-style: none;
        padding: 0;
        margin: 0;
        overflow-y: auto;
        width: 100%;
        height: 95%;
    }

    .side-menu-wrapper > ul > li > a {
        font-family: Nunito, sans-serif;
        color: #6b6b6b;
        transition: 0.3s;
        text-decoration: none;
        border-bottom: 2px solid #f6f6f6;
        padding: 0 10px 0 20px;
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        height: 100%;
        line-height: 65px;
        font-weight: 700;
        display: flex;
    }

    .side-menu-wrapper > ul > li > a div.icon {
        width: 25px;
        text-align: center;
        font-size: 20px;
    }

    .side-menu-wrapper > ul > li > a div.menu_title {
        margin-left: 15px;
    }

    .side-menu-wrapper > ul > li > a.active {
        color: #00a5cd;
        background: #f2f2f2;
        border-bottom: solid 1px #e3e3e3;
        border-top: none;
    }

    .side-menu-wrapper > ul > li > a.active .icon img {
        filter: opacity(0.5) drop-shadow(0 0 0 #00a5cd);
    }

    .side-menu-wrapper > a.menu-close {
        height: 80px;
        padding: 0px;
        color: #ffffff;
        display: block;
        margin: 0px;
        text-decoration: none;
        border-bottom: 2px solid #f6f6f6;
    }

    .side-menu-overlay {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.7);
        overflow-y: auto;
        overflow-x: hidden;
        text-align: center;
        opacity: 0;
        transition: opacity 1s;
    }

    .myaccount-logo .myaccount-img {
        position: relative;
        border-right: 2px solid #e9e9e9;
        padding-right: 13px;
    }

    .myaccount-logo span {
        color: #00a5cd;
        font-family: Nunito, sans-serif;
        font-size: 18px;
        font-style: normal;
        font-stretch: normal;
        font-weight: 500;
        text-align: left;
        vertical-align: middle;
        padding-left: 10px;
    }

    .myaccount-logo {
        text-align: center;
        padding-top: 15px;
        padding-bottom: 15px;
        line-height: 45px;
    }

    .slide-menu-open {
        font-size: 20px;
        font-weight: 100;
        font-family: Nunito, sans-serif;
    }

    .slide-menu-open > i {
        font-size: 25px;
    }

    .menu-img {
        max-width: 30px;
        max-height: 30px;
    }

    .navbar-dark .navbar-brand {
        font-size: 24px;
        font-weight: 600;
    }

</style>
